export const TTS_TYPES = ['openai', 'elevenlabs', 'amazon', 'google'];
export const TTS_MODELS = {
    openai: [{ value: 'tts-1', label: 'TTS-1' }],
    elevenlabs: [{ value: 'eleven_turbo_v2', label: 'Eleven Turbo V2' }],
    amazon: [],
    google: []
};
//'ballad',
export const TTS_VOICES = {
    openai: ['alloy', 'ash', 'coral', 'echo', 'fable', 'nova', 'onyx', 'sage', 'shimmer'],
    elevenlabs: [
        '2zRM7PkgwBPiau2jvVXc',
        'ZJDvsiCwIHOor8mlu5Uq',
        'a6mom163o5kVmXjYYKRm',
        'zs7UfyHqCCmny7uTxCYi',
        'ytF5gZp1KS6MUm5yXHZC',
        'rKoYWo69fjqa4LKrAnGP',
        'mCQMfsqGDT6IDkEKR20a',
        'siw1N9V8LmYeEWKyWBxv',
        'Qilebht6Y2g0yWy4xb2A',
        'TNHbwIMY5QmLqZdvjhNn'
    ],
    amazon: [
        "Kajal", "Danielle", "Gregory", "Ivy", "Joanna", "Kendra", "Kimberly", "Salli",
        "Joey", "Justin", "Kevin", "Matthew", "Ruth", "Stephen",
        "Amy", "Emma", "Brian", "Arthur", "Olivia", "Niamh", "Aria",
        "Jasmine", "Ayanda"
    ],
    google: [
        'en-IN-Chirp3-HD-Sulafat',
        'en-IN-Chirp-HD-D',
        'en-IN-Chirp-HD-F',
        'en-IN-Chirp-HD-O',
        'en-IN-Chirp3-HD-Achernar',
        'en-IN-Chirp3-HD-Achird',
        'en-IN-Chirp3-HD-Algenib',
        'en-IN-Chirp3-HD-Algieba',
        'en-IN-Chirp3-HD-Alnilam',
        'en-IN-Chirp3-HD-Aoede',
        'en-IN-Chirp3-HD-Autonoe',
        'en-IN-Chirp3-HD-Callirrhoe',
        'en-IN-Chirp3-HD-Charon',
        'en-IN-Chirp3-HD-Despina',
        'en-IN-Chirp3-HD-Enceladus',
        'en-IN-Chirp3-HD-Erinome',
        'en-IN-Chirp3-HD-Fenrir',
        'en-IN-Chirp3-HD-Gacrux',
        'en-IN-Chirp3-HD-Iapetus',
        'en-IN-Chirp3-HD-Kore',
        'en-IN-Chirp3-HD-Laomedeia',
        'en-IN-Chirp3-HD-Leda',
        'en-IN-Chirp3-HD-Orus',
        'en-IN-Chirp3-HD-Puck',
        'en-IN-Chirp3-HD-Pulcherrima',
        'en-IN-Chirp3-HD-Rasalgethi',
        'en-IN-Chirp3-HD-Sadachbia',
        'en-IN-Chirp3-HD-Sadaltager',
        'en-IN-Chirp3-HD-Schedar',
        'en-IN-Chirp3-HD-Umbriel',
        'en-IN-Chirp3-HD-Vindemiatrix',
        'en-IN-Chirp3-HD-Zephyr',
        'en-IN-Chirp3-HD-Zubenelgenubi',
        'en-IN-Neural2-A',
        'en-IN-Neural2-B',
        'en-IN-Neural2-C',
        'en-IN-Neural2-D',
        'en-IN-Standard-A',
        'en-IN-Standard-B',
        'en-IN-Standard-C',
        'en-IN-Standard-D',
        'en-IN-Standard-E',
        'en-IN-Standard-F',
        'en-IN-Wavenet-A',
        'en-IN-Wavenet-B',
        'en-IN-Wavenet-C',
        'en-IN-Wavenet-D',
        'en-IN-Wavenet-E',
        'en-IN-Wavenet-F'
    ]
};


export const arrStringToArrayObj = (data) => {
    return data?.map((item) => {
        return { label: item, value: item }
    })
}